@if (title() || titleTooltip() || locked()) {
  <div class="radio-card-group__header">
    @if (title(); as titleText) {
      <span class="radio-card-group__heading">
        {{ translateLabels() ? (titleText | transloco) : titleText }}
      </span>
    }
    @if (locked()) {
      <i class="mdi mdi-lock radio-card-group__lock-icon" aria-hidden="true"></i>
    }
    @if (titleTooltip(); as titleTipText) {
      <span
        #titleTip="ngbTooltip"
        container="body"
        class="radio-card-group__info-icon cursor-pointer"
        tooltipClass="ngb-tooltip-wide-m radio-card-group-tooltip"
        [ngbTooltip]="translateLabels() ? (titleTipText | transloco) : titleTipText"
        triggers="hover"
        (mouseleave)="titleTip.close()"
        (click)="$event.preventDefault()"
      >
        <i class="bx bx-question-mark text-info"></i>
      </span>
    }
  </div>
}

<div class="radio-card-group__options">
  @for (item of items(); track item.value) {
    <label
      class="radio-card-group__option"
      [class.is-selected]="currentValue() === item.value"
      [class.is-disabled]="disabled()"
    >
      <input
        type="radio"
        class="radio-card-group__radio"
        [name]="effectiveGroupName()"
        [formControl]="control()"
        [value]="item.value"
      />
      @if (item.iconSrc) {
        <span
          class="radio-card-group__svg-icon"
          aria-hidden="true"
          [style.-webkit-mask-image]="'url(' + item.iconSrc + ')'"
          [style.mask-image]="'url(' + item.iconSrc + ')'"
        ></span>
      } @else if (item.icon) {
        <i class="bx radio-card-group__icon" [ngClass]="item.icon"></i>
      }
      <div class="radio-card-group__text">
        <span class="radio-card-group__title-row">
          <span class="radio-card-group__title">
            {{ translateLabels() ? (item.label | transloco) : item.label }}
          </span>
          @if (item.tooltip; as tipText) {
            <span
              #itemTip="ngbTooltip"
              container="body"
              class="radio-card-group__info-icon cursor-pointer"
              tooltipClass="ngb-tooltip-wide-m radio-card-group-tooltip"
              [ngbTooltip]="translateLabels() ? (tipText | transloco) : tipText"
              triggers="hover"
              (mouseleave)="itemTip.close()"
              (click)="$event.preventDefault(); $event.stopPropagation()"
            >
              <i class="bx bx-question-mark text-info"></i>
            </span>
          }
        </span>
        @if (item.description; as descText) {
          <span class="radio-card-group__description">
            {{ translateLabels() ? (descText | transloco) : descText }}
          </span>
        }
      </div>
    </label>
  }
</div>
